export default "__VITE_ASSET__BJcJvyP2__"